import { compose } from 'redux'

// local higher-order components
import withRedux from './withRedux'
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'
import withFormResults from './withFormResults'

// presentational component
import UI from './UI'

export default compose(
  withRedux, // for form and error state
  withFormResults, // for mutation result handling
  withMutation, // for saving payment and performing checkout
  withEventHandlers // for handling UI interactions
)(UI)
